import React, { useState } from 'react';
import { Button, Toast, ToastContainer } from 'react-bootstrap';
import { RefreshCw } from 'lucide-react';
import { analyticsAPI } from '../services/api';

const RefreshButton = ({ onRefreshComplete }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

  const handleRefresh = async () => {
    setIsRefreshing(true);
    
    try {
      const result = await analyticsAPI.refreshData();
      
      if (result.success) {
        setToastMessage(result.message || 'Data refreshed successfully!');
        setToastVariant('success');
        if (onRefreshComplete) {
          onRefreshComplete();
        }
      } else {
        setToastMessage(result.message || 'Failed to refresh data');
        setToastVariant('danger');
      }
    } catch (error) {
      console.error('Error refreshing data:', error);
      setToastMessage('Failed to refresh data. Please try again.');
      setToastVariant('danger');
    } finally {
      setIsRefreshing(false);
      setShowToast(true);
    }
  };

  return (
    <>
      <Button
        variant="warning"
        className="refresh-btn"
        onClick={handleRefresh}
        disabled={isRefreshing}
      >
        <RefreshCw 
          className={`me-1 ${isRefreshing ? 'spin' : ''}`} 
          size={16} 
        />
        {isRefreshing ? 'Refreshing...' : 'Refresh Data'}
      </Button>

      <ToastContainer position="top-end" className="p-3">
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={5000}
          autohide
          bg={toastVariant}
        >
          <Toast.Header>
            <strong className="me-auto">
              {toastVariant === 'success' ? 'Success' : 'Error'}
            </strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            {toastMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default RefreshButton;
